import { ReactNode, useEffect, useRef } from "react";
import Animated, {
	useAnimatedStyle,
	useSharedValue,
	withRepeat,
	withSequence,
	withTiming,
} from "react-native-reanimated";

const AnimatedSelectionWrapper = ({
	isSelected,
	borderRadius,
	children,
}: {
	isSelected: boolean;
	borderRadius: number;
	children: ReactNode;
}) => {
	const borderSV = useSharedValue(isSelected ? 1 : 0);
	const translateSV = useSharedValue(0);
	const scaleSV = useSharedValue(1);
	const didInit = useRef(false);
	useEffect(() => {
		if (!didInit.current) {
			didInit.current = true;
			return;
		}
		if (isSelected) {
			borderSV.value = withTiming(1, { duration: 200 });
			translateSV.value = withRepeat(
				withSequence(
					withTiming(-5, {
						duration: 50,
					}),
					withTiming(0, {
						duration: 200,
					}),
				),
				2,
			);
		} else {
			borderSV.value = withTiming(0, { duration: 200 });
		}
	}, [isSelected, borderSV, translateSV]);

	const animatedStyle = useAnimatedStyle(() => {
		return {
			opacity: Math.max(0, borderSV.value - 0.5) / 0.5,
		};
	}, [borderSV]);
	const bounceAnimatedStyle = useAnimatedStyle(() => {
		return {
			transform: [
				{ translateY: translateSV.value },
				{
					scale: scaleSV.value,
				},
			],
		};
	}, [translateSV, scaleSV]);

	return (
		<>
			<Animated.View
				style={[
					{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						borderRadius,
						borderWidth: 2,
						borderColor: "#FFFFFF",
						borderStyle: "solid",
					},
					animatedStyle,
				]}
			/>
			<Animated.View style={bounceAnimatedStyle}>{children}</Animated.View>
		</>
	);
};
export default AnimatedSelectionWrapper;
